import {
  AfterContentInit,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  NgModule,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { SystemModalDirectiveModule } from './directives';
import { CommonModule } from '@angular/common';
import { TemplateDirective } from '../../organisms';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-system-modal',
  styleUrl: './modal.component.scss',
  templateUrl: './modal.component.html',
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        animate(
          '300ms ease-out',
          keyframes([
            style({
              transform: 'scale(0.5)',
              opacity: 0,
              offset: 0,
            }),
            style({
              transform: 'scale(1.05)',
              opacity: 1,
              offset: 0.7,
            }),
            style({
              transform: 'scale(1)',
              opacity: 1,
              offset: 1.0,
            }),
          ])
        ),
      ]),
    ]),
  ],
})
export class ModalComponent implements AfterContentInit {
  @Input({ required: true }) isOpen = false;
  @Input() title?: string;
  @Input() showCloseButton = true;
  @Input() showBackdrop = true;
  @Input() backdropOpacity = 0.5;
  @Input() isDraggable = false;
  @Input() showDivisors = true;
  @Input() modalClasses = '';

  @Output() closeModal = new EventEmitter<void>();

  @ViewChild('modalElement') modalElement!: ElementRef;

  @ContentChildren(TemplateDirective) templates!: QueryList<TemplateDirective>;

  modalBodyTemplate!: TemplateRef<any>;
  modalFooterTemplate!: TemplateRef<any>;

  ngAfterContentInit(): void {
    this.templates.forEach(template => {
      switch (template.name) {
        case 'body':
          this.modalBodyTemplate = template.template;
          break;
        case 'footer':
          this.modalFooterTemplate = template.template;
          break;
      }
    });
  }

  // Method to close the modal
  close(): void {
    this.closeModal.emit();
  }
}

@NgModule({
  declarations: [ModalComponent],
  exports: [ModalComponent],
  imports: [CommonModule, SystemModalDirectiveModule],
})
export class SystemModalModule {}
